import { UseQueryResult } from '@tanstack/react-query'
import { GetHomeQuizResponse, getHomeQuiz } from '@tmap-web-lib/remote-api-client/frontman'
import { AxiosError } from 'axios'
import { useAtomValue } from 'jotai'

import { mockHost } from '@/apis'
import { storageMockEnabled } from '@/atoms'
import { useQueryWrapper } from '@/hooks/useQueryWrapper'
import { KEYS } from '@/react-query/keys'

interface Props {
  useErrorBoundary?: boolean
}

function useGetHomeQuiz(props?: Props): UseQueryResult<GetHomeQuizResponse | null, AxiosError> {
  const storageMock = useAtomValue(storageMockEnabled)

  return useQueryWrapper<GetHomeQuizResponse | null, AxiosError>(
    KEYS.HOME_QUIZ(),
    async () => {
      if (storageMock) {
        const { data } = await mockHost.get<GetHomeQuizResponse | null>(
          '/square-admin/user/api/surveys/home-quiz'
        )
        return data
      } else {
        const { data } = await getHomeQuiz()
        return data
      }
    },
    {
      useErrorBoundary: props?.useErrorBoundary ?? true,
    }
  )
}

export { useGetHomeQuiz }
